import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import Loading from "../helpers/loading_component.js";
import emailjs from "@emailjs/browser";
import LoadingPopup from "../helpers/loading_component.js";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import { secretKey } from "../.././data";

const MySwal = withReactContent(Swal2);

const SendSellClientSMS = (props) => {
  const [loading, setLoading] = useState(true);
  const [template, setTemplate] = useState("");
  const [value, setValue] = useState("");
  const [status, setStatus] = useState([]);
  const [templates, setTemplates] = useState([]);

  const fetchTemplates = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getSellSMSTemplates", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setTemplates(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    fetchTemplates();
  };

  useEffect(() => {
    getData();
  }, []);

  const modules = {
    toolbar: [
      ["bold", "italic", "underline", "strike", "blockquote"],
      [{ color: [] }],
      [{ list: "ordered" }, { list: "bullet" }],
      [
        { align: "" },
        { align: "center" },
        { align: "right" },
        { align: "justify" },
      ],
      ["link"],
    ],
  };

  const handleTemplateChange = (e) => {
    setTemplate(e.target.value);
    var content = templates
      .filter((el) => +el.id === +e.target.value)[0]
      .content.replaceAll(
        "{{link}}",
        "https://workflow.kppp.pl/?clientUpload=1&client=" + props.leadData.id
      )
      .replaceAll(
        "{{phone}}",
        props.uData.phone === "null" ? "(brak numeru)" : props.uData.phone
      )
      .replaceAll(
        "{{mail}}",
        props.uData.phone === "null" ? "(brak adresu)" : props.uData.mail
      )
      .replaceAll("{{user_name}}", props.uData.name);
    setValue(content);
  };

  const addClientContact = async () => {
    var body = {
      type: "SMS",
      content: value.replaceAll(/(<([^>]+)>)/gi, " "),
      date: new Date(),
      leadId: props.leadData.id,
      user: props.uData.name,
    };

    await fetch("https://apidevkppp.ftpeople.pl/addSellClientContact", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        props.logClientAction("Dodano kontakt z klientem", props.leadData.id);
        if (props.mode === "sellTask") {
          props.close();
        } else {
          MySwal.fire({
            icon: "success",
            title: "Wysłano",
            text: "wiadomość do klienta",
          }).then(async (result) => {
            props.close();
          });
        }
      })
      .catch((error) => {});
  };

  const setStatusX = () => {
    if (props.mode === "sellTask") {
      sendMail();
      return;
    }

    if (props.uData.role === "consultantTele") {
      sendMail();
    } else {
      sendMail();
    }
  };

  const sendMail = async () => {
    if (template) {
      setLoading(true);
      props.logClientAction(
        "Wysłano sms: " + "'" + value + "'",
        props.leadData.id
      );

      var body = {
        phone: props.leadData.phone,
        content: value,
      };

      fetch("https://apidevkppp.ftpeople.pl/sendSMS", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.text())
        .then((data) => {
          addClientContact();
        })
        .catch((error) => {});
    } else {
      MySwal.fire({
        icon: "error",
        title: "Wybierz",
        text: "szablon wiadomości",
      }).then(async (result) => {});
    }
  };

  return (
    <div
      style={{ width: "50vw", top: "10vh" }}
      className="mainContainerAddClientContact"
    >
      {loading ? (
        <LoadingPopup id={"popUpLoading"} />
      ) : (
        <>
          <div className="closeBox">
            <button className="closeClientButton" onClick={props.close}>
              X
            </button>
          </div>

          <div
            style={{
              overflowY: "scroll",
              maxHeight: "65vh",
              scrollbarWidth: "auto",
            }}
            id="addPaymentIC"
            className="inputContainer"
          >
            <div className="inputBox">
              <div style={{ minWidth: "95%" }} className="inputCol_1">
                <label>
                  Wybierz szablon <span className="requiredStar">*</span>
                </label>
                <select
                  type="text"
                  id="court"
                  name="court"
                  value={template}
                  onChange={handleTemplateChange}
                >
                  {!template ? (
                    <option key={0} value="0">
                      Wybierz...
                    </option>
                  ) : (
                    ""
                  )}
                  {templates.map((el) => (
                    <>
                      <option key={el.id} value={el.id}>
                        {el.name}
                      </option>
                    </>
                  ))}
                </select>
              </div>
            </div>
            <label style={{ marginTop: "2vh" }}>Wiadomość</label>
            <div
              style={{
                marginTop: "1vh",
                border: "1px solid black",
                borderRadius: "15px",
                width: "95%",
              }}
            >
              <ReactQuill
                theme="snow"
                value={value}
                onChange={setValue}
                modules={modules}
              />
            </div>

            <div className="saveBoxAP">
              <button className="paymentMenuButton" onClick={setStatusX}>
                Wyślij
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default SendSellClientSMS;
